import * as React from 'react'
import { Col, Row, Timeline, Icon } from 'antd'
import VimeoPlayer from 'react-player/lib/players/Vimeo'
import { StaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'
import * as _ from 'lodash'

import styled from 'styled-components'

import { Video } from './Video'
import { Consumer } from '../routes/public/Lecture'
import { StyledCourseHeading } from '../../styles/styledComponents'
import Markdown from './Markdown'

export const StyledTimeline = styled(Col)`
  ${({ theme }) => `
        padding: ${theme['padding-small']};
    `}
`

const StyledLock = styled(Icon)`
  font-size: 16px;
  border-radius: 50%;
  background-color: white;
  margin-left: 2px;
  margin-top: 0px;
  padding: 3px;
  border: 2px solid #442d6b;
`

export const StyledOneTimeline = styled(Timeline.Item)`
  ${({ selected }: { selected: boolean }) => `
    padding: 0 0 10px; 

    .ant-timeline-item-head{
        width: 20px;
        height: 20px;
        margin-left: -4px;
        margin-top: -4px;
        background-color: ${selected ? '#442d6b' : '#ffffff'}
    }  
    p {
      margin: 0px;
      margin-left: 6px;
      font-size: 16px;
      font-weight: bold;
    }
  `}
  ${({ theme, showlock }) =>
    showlock === 'true'
      ? `
      div {
        background-color: transparent !important;
        padding: 0;
      }
  `
      : ``}
`

const StyledTitle = styled.h4`
  ${({ theme }) => {
    return `
  font-size: 24px;
  text-align: left;
  padding: ${theme['padding-small']};
  margin-bottom: ${theme['margin-lg']};
  margin-top: ${theme['margin-lg']};
  color: #442d6b;
`
  }}
`

const Lecture = ({ hasBought, path }: { hasBought: boolean; path: string }) => {
  const courseName = path.split('/')[2]
  return (
    <StaticQuery
      query={graphql`
        {
          allMdx {
            edges {
              node {
                id
                frontmatter {
                  lectureTitle
                  paid
                }
                fields {
                  lecturePath
                  lectureNumber
                }
              }
            }
          }
        }
      `}
      render={({ allMdx: { edges: lectures } }) => {
        return (
          <Consumer>
            {({
              frontmatter: {
                title,
                starterFilesLink,
                video,
                lectureTitle,
                paid,
              },
              path,
            }) => {
              return (
                <>
                  <StyledCourseHeading>
                    <Col span={22} offset={1}>
                      <h1>{title}</h1>
                      <p>
                        Start at the beginning and work your way through this
                        project. The code for each step as well as the finished
                        project can be found in the{' '}
                        <a target="_blank" href={starterFilesLink}>
                          Github repository
                        </a>
                        .
                      </p>
                      <hr />
                    </Col>
                  </StyledCourseHeading>
                  <Row>
                    <StyledTimeline
                      md={{ span: 5, offset: 1 }}
                      sm={{ offset: 1, span: 22 }}
                    >
                      <Timeline>
                        {_.sortBy(
                          _.filter(lectures, o =>
                            o.node.fields.lecturePath.includes(courseName)
                          ),
                          o => parseInt(o.node.fields.lectureNumber)
                        ).map(
                          ({
                            node: {
                              frontmatter: {
                                lectureTitle: currentLectureTitle,
                                paid: currentPaid,
                              },
                              fields: { lecturePath, lectureNumber },
                            },
                          }) => {
                            return (
                              <StyledOneTimeline
                                showlock={`${currentPaid && !hasBought}`}
                                selected={lecturePath + '/' === path}
                                key={lectureNumber}
                                dot={
                                  currentPaid && !hasBought ? (
                                    <StyledLock type="lock" />
                                  ) : null
                                }
                              >
                                <Link to={lecturePath} replace>
                                  <p>{`${parseInt(
                                    lectureNumber
                                  )}. ${currentLectureTitle}`}</p>
                                </Link>
                              </StyledOneTimeline>
                            )
                          }
                        )}
                      </Timeline>
                    </StyledTimeline>
                    <Col md={{ span: 16 }} sm={{ offset: 1, span: 22 }}>
                      <Video video={video} />
                      <StyledTitle>{`${parseInt(
                        path.match(/\d+/)[0]
                      )}. ${lectureTitle}`}</StyledTitle>
                      <Markdown />
                    </Col>
                  </Row>
                </>
              )
            }}
          </Consumer>
        )
      }}
    />
  )
}

export default Lecture
